<template>
  <div class="accountbodylist">
    <div class="row">
      <div class="col-md-8 accountorder">
        <h3 class="secondary_title">{{$t('account.order_history')}}</h3>
        <table class="table order secondary_title " v-if="orders.total">
          <thead>
            <tr style="word-break: normal;">
              <th>{{$t('account.order')}}</th>
              <th>{{$t('account.date')}}</th>
              <th>{{$t('account.payment_status')}}</th>
              <th>{{$t('account.fulfillment_status')}}</th>
              <th>{{$t('account.total')}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in orders.data" :key="item.id">
              <td class="clearfix">
                <span>{{$t('account.order')}}</span>
                <i>
                  <a :href="'/account/order/'+item.ID" style="white-space:nowrap">#{{item.ID}}</a>
                </i>
              </td>
              <td class="clearfix">
                <span>{{$t('account.date')}}</span>
                <i>{{item.post_date}}</i>
              </td>
              <td class="clearfix">
                <span>{{$t('account.payment_status')}}</span>
                <i> {{$t(`account.${item.financial_status}`)}}</i>
              </td>
              <td class="clearfix">
                <span>{{$t('account.fulfillment_status')}}</span>
                <i>{{item.fulfillment_status == 'unfulfilled' ? $t('account.unfulfilled') : item.fulfillment_status == "fulfilled" ? $t('account.fulfilled') : item.fulfillment_status}}</i>
              </td>
              <td class="clearfix">
                <span>{{$t('account.total')}}</span>
                <v-selectprice :price="item.order_total-0" :disable_select="!(showCurrencySelector && currencySelectorType == 'global')" :appendToBody="false"></v-selectprice>
                <!-- <i>${{(item.order_total-0).toFixed(2)}}</i> -->
              </td>
            </tr>
            <tr v-if="orders.total>10" class="el-page">
              <td colspan="5">
                <el-pagination
                  :small="small"
                  layout="prev, pager, next"
                  :total="orders.total"
                  @current-change="changepage"
                  background
                  :pager-count="5"
                ></el-pagination>
              </td>
            </tr>
          </tbody>
        </table>
        <h4 class="page_text_font" v-else>{{$t('account.not_placed_any_orders')}}</h4>
      </div>
      <div class="col-md-4 accountaddress">
        <h3 class="secondary_title ">{{$t('account.account_details')}}</h3>
        <!-- <h4>{{user.first_name}} {{user.last_name}}</h4> -->
        <v-addressitem :service="service" :addressitem="defaultaddress"></v-addressitem>
        <p class="viewaddresses">
          <a class="secondary_title " href="/account/address">{{$t('account.view_addresses')}} ({{this.user.address_book.length}})</a>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import vAddressitem from "./addressitem";
// import API from "../../../API";
import { mapState } from 'vuex';
export default {
  props: ["email", "user", "defaultaddress", "service"],
  data() {
    return {
      orders: [],
      small: false,
      // reverseorders: []
    };
  },
  methods: {
    async changepage(e) {
      try {
        let res = await this.$axios.get(API.getorders + "?page=" + e);
        // this.orders = res.data;
        this.orders = {
          data:res.data.data,
          first_page_url:res.data.links.first,
          last_page_url:res.data.links.last,
          next_page_url:res.data.links.next,
          prev_page_url:res.data.links.prev,
          ...res.data.meta,
        };
      } catch (error) {
        if (
          error?.response?.data?.message
        ) {
          this.$message.error(error.response.data.message);
        }
      }
    },
  },
  mounted() {
    this.small = this.$(window).width() <= 575;
    console.log(this.user);
    this.orders = this.user.orders;
  },
  components: {
    vAddressitem,
  },
  computed:{
    ...mapState({
      showCurrencySelector: ({ options }) => options?.theme?.global?.show_currency_selector,
      currencySelectorType: ({ options }) => options?.theme?.global?.currency_selector_type
    })
  },
};
</script>
<style scoped lang='scss'>
.accountbodylist {
  margin-top: 50px;
  text-align: left;

  h3 {
    font-size: 20px;
  }

  h4 {
    font-size: 15px;
  }

  .accountorder {
    margin-bottom: 50px;

    .order {
      display: block;
      margin: 0;
      overflow: auto;
      padding-left: 15px;
      padding-right: 15px;
      background-color: rgb(246, 246, 246);

      thead {
        tr {
          border-bottom: 1px solid black;

          th {
            text-align: left;
            border: none;
            vertical-align: middle;
            font-size: 13px;
            font-weight: 600;
            padding: 15px;
          }

          & > th:last-child {
            text-align: right;
          }
        }
      }

      tbody {
        & > tr {
          td {
            text-align: left;
            border: none;
            vertical-align: middle;
            font-size: 16px;
            padding: 10px 15px;
            span {
              display: none;
              max-width: 60%;
            }

            i {
              font-style: normal;

              a {
                font-size: 15px;
                text-decoration: none;
                color: black;
              }
            }
          }

          & > td:last-child {
            i {
              float: right;
            }
            .selectpricewrap {
              float: right;
            }
          }
        }
        .el-page {
          td {
            padding-left: 0;
            padding-right: 0;
            text-align: center;
          }
        }
      }
    }
  }

  .accountaddress {
    .addresslist {
      li {
        margin-bottom: 15px;
      }
    }

    .viewaddresses {
      a {
        color: red;
        text-decoration: none;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .accountbodylist {
    .accountorder {
      .order {
        display: table;

        & > thead {
          display: none;
        }

        tbody {
          tr {
            border-bottom: 1px solid black;

            td {
              display: block;
              border: none !important;
              font-size: 14px;
              span {
                display: inline-block;
              }

              i {
                float: right;
                max-width: 40%;
                text-align: right;
              }
            }
            & > td:last-child {
              .selectpricewrap {
                &::v-deep {
                  .pricelistbox {
                    right: 50px;
                  }
                }
              }
            }
          }

          & > tr:last-child {
            border-bottom: none;
          }
        }
      }
    }
  }
}
</style>
